export default "__VITE_ASSET__DSl1Zakf__"